import { createAction } from '@reduxjs/toolkit';

export const setTemplatePermission = createAction('permission/set_template_permissions');
export const setElementPermission = createAction('permission/set_element_permissions');
